// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__1SyaI","title":"Widget_title__144sH"};